import axios from 'axios';
import { API_BASE_URL, API_PREFIX } from './config';

const api = axios.create({
  baseURL: API_BASE_URL + API_PREFIX,
  timeout: 60000, // 60秒超时，给AI生成留足时间
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      const url = config.url || '';
      if (url.includes('/auth/login') || url.includes('/auth/register')) {
        config.headers['X-User-Id'] = '';
      }
    }

    const user = localStorage.getItem('user');
    if (user) {
      try {
        const userData = JSON.parse(user);
        if (userData.id) {
          config.headers['X-User-Id'] = userData.id.toString();
        }
      } catch (e) {
      }
    }

    const csrfToken = localStorage.getItem('csrf_token');
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    const csrfToken = response.headers['x-csrf-token'] || response.headers['X-CSRF-Token'];
    if (csrfToken) {
      localStorage.setItem('csrf_token', csrfToken);
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      if (url.includes('/auth/login') || url.includes('/auth/register')) {
        return Promise.reject(error);
      }

      // 简历模板下载相关接口：不要触发全局登出。
      // 这些接口的401应由页面自行提示（例如弹出"请重新登录"），避免点击下载把用户直接踢回首页。
      if (url.includes('/resume-templates')) {
        return Promise.reject(error);
      }

      const { handleAxiosAuthError } = await import('./authErrorHandler');
      return handleAxiosAuthError(error);
    }
    return Promise.reject(error);
  }
);

export default api;
